import axios from "axios";

const teams = {

    async createBulk(project_id, teams){
        return (await axios.post(`/api/project/${project_id}/team/create/bulk`, {teams})).data;
    },

    async destroy(team_id){
        return (await axios.delete(`/api/team/${team_id}`)).data;
    },

    async removeStudent(team_id, student_id){
        return (await axios.delete(`/api/team/${team_id}/student/${student_id}`)).data;
    },

    async createStudents(team_id, students){
        return (await axios.post(`/api/team/${team_id}/student`, {students})).data;
    },

    async updateBulk(team){
        return (await axios.put(`/api/team/${team.id}/bulk`, {team})).data;
    },

    async update(team_id, changes){
        return (await axios.put(`/api/team/${team_id}`, changes)).data;
    }

}


export default teams;
